// import React from "react";
import { Link } from "react-router-dom";
// import footerMailIcon from "../../assets/images/inicio/icono email.png";
import styles from "./Footer.module.css";
import logoImage from "../../assets/images/inicio/LOGO_EL INDUSTRIAL.png";

const Footer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <img
          className={styles.logoImg}
          src={logoImage}
          alt="Logo"
          loading="lazy"
        />
        <div className={styles.columnSmall}>
          <Link to="/" className={styles.linkText}>
            Inicio
          </Link>
          <Link to="/somos" className={styles.linkText}>
            Somos
          </Link>
          <Link to="/servicios" className={styles.linkText}>
            Servicios
          </Link>
        </div>

        <div className={styles.columnLarge}>
          <Link to="/galeria" className={styles.linkText}>
            Galería
          </Link>
          <Link to="/contacto" className={styles.linkText}>
            Contacto
          </Link>
          {/* <Link to="/catalogo" className={styles.linkText}>
            Catálogo
          </Link> */}
          <Link to="/aviso" className={styles.linkText}>
            Aviso de privacidad
          </Link>
        </div>
      </div>

      <div className={styles.bottomBar} />

      <div className={styles.copyright}>
        Copyright © 2025 Revista El Industrial de Monterrey. Todos los derechos
        reservados.
      </div>

      {/* <div className={styles.newsletterContainer}>
        <div className={styles.newsletterTitle}>
          ¡Suscríbete a nuestro NewsLetter!
        </div>
        <input
          type="email"
          placeholder="Correo electrónico"
          className={styles.newsletterInput}
        />

        <button className={styles.subscribeButton}>
          <div className={styles.subscribeButtonText}>Suscríbete</div>
        </button>
      </div> */}

      {/* <img
        className={styles.footerMailIcon}
        src={footerMailIcon}
        alt="Mail Icon"
        loading="lazy"
      /> */}
    </div>
  );
};

export default Footer;
